import {
    type AttendanceEventMetrics,
    type MarkedAttendanceMetrics,
    type SessionAttendanceSummary
} from '../../components/attendance/types';
import { type ClassSession, type ClassStudent } from '../types';

interface MakeAttendanceDataProps {
    students: ClassStudent[];
    session: ClassSession;
}

export interface AttendanceData {
    events: AttendanceEventMetrics | null;
    marks: MarkedAttendanceMetrics | null;
    ext_user_id: string | null;
    email: string | null;
}

export const makeAttendanceData = ({ students, session }: MakeAttendanceDataProps): SessionAttendanceSummary => {
    const studentAttendanceRate = 0.9;

    const attendance: SessionAttendanceSummary = {
        session_id: session.session_id,
        students: {}
    };

    students.forEach((student) => {
        const isPresent = Math.random() < studentAttendanceRate;

        attendance.students[student.student_id] = {
            events: {
                duration: 61,
                join_time: '',
                leave_time: '',
                present: isPresent,
                tardy: false
            },
            marks: {
                marked_tardy: false,
                marked_present: isPresent,
                marked_duration: 90,
                marked_join_time: '',
                marked_leave_time: ''
            },
            ext_user_id: student.ext_user_id,
            email: student.email
        };
    });

    return attendance;
};
